import React, { useEffect, useRef, useState } from 'react'
import style from '../../chatModule/chatscreen.module.scss'
import TextareaAutosize from 'react-textarea-autosize'
import { images } from '../../../assets'
import { database, storageRef } from '../../../utils/firebase'
import { useSelector } from 'react-redux'

const ChatFooter = ({ conversationID, patientID }) => {
  const [textareaValue, setTextareaValue] = useState('')
  const me = useSelector((state) => state.app.me) // Get user information from Redux
  const inputRef = useRef(null)
  const [selectedImage, setSelectedImage] = useState(null)


  const handleTextAreaChange = (event) => {
    setTextareaValue(event.target.value) // Update local state
  }

  const sendMessage = async () => {
    if (!textareaValue.trim()) return

    const newChatKey = database.ref(`/conversations/${conversationID}/`).push().key
    const updates = {}
    console.log('conversationID, pdr', conversationID)


    updates[`/conversations/${conversationID}/${newChatKey}/content`] = textareaValue
    updates[`/conversations/${conversationID}/${newChatKey}/doctorImgURL`] = me.profileImageURL
    updates[`/conversations/${conversationID}/${newChatKey}/doctorName`] = me.doctorName
    updates[`/conversations/${conversationID}/${newChatKey}/fromID`] = me.id
    updates[`/conversations/${conversationID}/${newChatKey}/toID`] = patientID || null
    updates[`/conversations/${conversationID}/${newChatKey}/isRead`] = false
    updates[`/conversations/${conversationID}/${newChatKey}/timestamp`] = Date.now()
    updates[`/conversations/${conversationID}/${newChatKey}/type`] = 'text'

    await database.ref().update(updates) // Update Firebase with new message
    setTextareaValue('') // Clear the textarea after sending message
  }
  useEffect(() => {
    const uploadImageAndUpdateDatabase = async () => {
      try {
        const newKey = database.ref(`/conversations/${conversationID}/`).push().key
        const updates = {}
        if (selectedImage) {
          const ref = storageRef().ref(`consultAttachment/${new Date().getTime()}`)
          // eslint-disable-next-line no-await-in-loop
          const snapshot = await ref.put(selectedImage)
          // eslint-disable-next-line no-await-in-loop
          const str = await snapshot.ref.getDownloadURL()

          updates[`/conversations/${conversationID}/${newKey}/content`] = str
          updates[`/conversations/${conversationID}/${newKey}/doctorImgURL`] = me.profileImageURL
          updates[`/conversations/${conversationID}/${newKey}/doctorName`] = me.doctorName
          updates[`/conversations/${conversationID}/${newKey}/fromID`] = me.id
          updates[`/conversations/${conversationID}/${newKey}/toID`] = patientID || null
          updates[`/conversations/${conversationID}/${newKey}/isRead`] = false
          updates[`/conversations/${conversationID}/${newKey}/timestamp`] = new Date().getTime()
          updates[`/conversations/${conversationID}/${newKey}/type`] = 'image'
          // eslint-disable-next-line no-use-before-define
          await database.ref().update(updates)

          setSelectedImage('')
        }
      } catch (error) {
        console.error('Error uploading image and updating database:', error)
      }
    }

    if (selectedImage) {
      uploadImageAndUpdateDatabase()
    }
  }, [selectedImage])


  return (
    <div>
      <div className={style.footer}>
        <div className={style.sendBox}>
          <div className={style.sendBoxRow}>
            <TextareaAutosize
              name="message"
              placeholder="Please type here"
              className={style.valid}
              value={textareaValue}
              onChange={handleTextAreaChange}
            />
            <div className={style.attachmentButton}>
              <img
                src={images.attachment}
                onClick={() => inputRef.current.click()}
                alt="logo"
              />
              <input
                id="image"
                name="image"
                ref={inputRef}
                type="file"
                style={{ display: 'none' }}
                accept="image/*"
                onChange={(event) => {
                  setSelectedImage(event.target.files[0])
                }}
              />
              <button className={style.sendButton} onClick={sendMessage}>
                <img src={images.send} className={style.sendIcon} alt="Send" />
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}
export default ChatFooter
